import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteInstituteType } from '../hooks/useDeleteInstituteType';
import type { InstituteType } from '../types/instituteType.types';

interface InstituteTypeDeleteConfirmationProps {
  instituteType: InstituteType | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function InstituteTypeDeleteConfirmation({
  instituteType,
  open,
  onOpenChange,
}: InstituteTypeDeleteConfirmationProps) {
  const { mutate, isPending } = useDeleteInstituteType();

  function handleConfirm() {
    if (!instituteType) return;
    mutate(instituteType.id, { onSuccess: () => onOpenChange(false) });
  }

  const description = instituteType
    ? `"${instituteType.name}" will be permanently removed. This action cannot be undone.`
    : '';

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete institute type?"
      description={description}
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={isPending}
      pendingLabel="Deleting..."
      onConfirm={handleConfirm}
    />
  );
}
